import React from "react";
import "./CityCab.css";
import { Link } from "react-router-dom";
import sedancab from "../../assets/sedancab.png";
import  minicab from "../../assets/minicab.png";
import hatchback from "../../assets/hatchback.png";
import compactsedan from "../../assets/compactsedan.png";
import luxurysedan from "../../assets/luxurysedan.png";
import miniSUV from "../../assets/miniSUV.png";
import  SUVcab from "../../assets/SUVcab.png";
import cityride from "../../assets/cityride.png";
import familycab from "../../assets/familycab.png";
import primesedan from "../../assets/primesedan.png";
import ecocab from "../../assets/ecocab.png";
import premiumcab from "../../assets/premiumcab.png";
import urbancab from "../../assets/urbancab.png";
import metrocab from "../../assets/metrocab.png";
import tourcab from "../../assets/tourcab.png";
import executivecab from "../../assets/executivecab.png";
import  travelercab from "../../assets/travelercab.png";
import airportcab from "../../assets/airportcab.png";

const cabData = [
  {
    id: 2,
    name: "Sedan Cab",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1120,
    image: sedancab,
  },
  {
    id: 3,
    name: "Mini Cab",
    passenger: "3 Passenger",
    fuel: "CNG",
    price: 190,
    image: minicab,
  },
  {
    id: 4,
    name: "Hatchback",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1100,
    image: hatchback,
  },
  {
    id: 5,
    name: "Compact Sedan",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1130,
    image: compactsedan,
  },
  {
    id: 6,
    name: "Luxury Sedan",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1200,
    image: luxurysedan,
  },
  {
    id: 7,
    name: "Mini SUV",
    passenger: "5 Passenger",
    fuel: "Diesel",
    price: 1160,
    image: miniSUV,
  },
  {
    id: 8,
    name: "SUV Cab",
    passenger: "6 Passenger",
    fuel: "Diesel",
    price: 1180,
    image: SUVcab,
  },
  {
    id: 9,
    name: "City Ride",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 1110,
    image: cityride,
  },
  {
    id: 10,
    name: "Family Cab",
    passenger: "5 Passenger",
    fuel: "Petrol",
    price: 1150,
    image: familycab,
  },
  {
    id: 11,
    name: "Prime Sedan",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1170,
    image: primesedan,
  },
  {
    id: 12,
    name: "Eco Cab",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 195,
    image: ecocab,
  },
  {
    id: 14,
    name: "Premium Cab",
    passenger: "4 Passenger",
    fuel: "Diesel",
    price: 1190,
    image: premiumcab,
  },
  {
    id: 15,
    name: "Urban Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1140,
    image: urbancab,
  },
  {
    id: 16,
    name: "Metro Cab",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 1105,
    image: metrocab,
  },
  {
    id: 17,
    name: "Tour Cab",
    passenger: "6 Passenger",
    fuel: "Diesel",
    price: 1210,
    image: tourcab,
  },
  {
    id: 18,
    name: "Executive Cab",
    passenger: "4 Passenger",
    fuel: "Petrol",
    price: 1220,
    image: executivecab,
  },
  {
    id: 19,
    name: "Traveler Cab",
    passenger: "7 Passenger",
    fuel: "Diesel",
    price: 1250,
    image: travelercab,
  },
  {
    id: 20,
    name: "Airport Cab",
    passenger: "4 Passenger",
    fuel: "CNG",
    price: 1130,
    image: airportcab,
  },
];


const CityCab = () => {
  return (
    <div className="city-cab-container">
      {cabData.map((cab) => (
        <Link
          to="/adventure-traveller-detail-page"
          className="city-cab-link"
          state={{
            carData: cab,
            totalPrice: cab.price, // ✅ sending price
            pickup: "Your Location",
          }}
          key={cab.id}
        >
          {" "}
          <div className="city-cab-card" key={cab.id}>
            {/* Fuel Tag */}
            <div className="city-fuel-tag">{cab.fuel}</div>

            {/* Price Tag */}
            <div className="city-price-tag"> ₹ {cab.price}</div>
            <div className="city-cab-image-div">
              {/* Image */}
              <img src={cab.image} alt={cab.name} className="city-cab-image" />
            </div>
            {/* Content */}
            <div className="city-cab-content">
              <h2>{cab.name}</h2>
              <p>{cab.passenger}</p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default CityCab;
